import { Skeleton as MuiSkeleton } from '@mui/material';

//A wrapper for the MUI Skeleton component in case a change is made away from MUI

interface SkeletonProps {
  variant?: 'text' | 'rectangular' | 'rounded' | 'circular';
  width?: number;
  height?: number;
  className?: string;
  spacing?: number;
}

export const Skeleton = ({ variant, width, height, className, spacing }: SkeletonProps) => {
  const marginTopBottomStyle = spacing
    ? { marginBottom: `${spacing}em`, marginTop: `${spacing}em` }
    : {};

  return (
    <MuiSkeleton
      variant={variant}
      width={width}
      height={height}
      className={className}
      style={marginTopBottomStyle}
    />
  );
};
